
import Vue from 'vue';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import KitToolsFiltersAndSelection from './components/KitToolsFiltersAndSelection.vue';
import { KIT_TYPE } from '@/views/Runnits/constants';
import { setKitPreference } from '@/utils/localStorage';
import { KitsMixin } from '@/mixins/KitsMixin';

export default Vue.extend({
	name: 'KitDialogSelect',
	mixins: [
		KitsMixin,
	],
	components: {
		DialogOrBottomSheet,
		KitToolsFiltersAndSelection,
	},
	props: {
		isOpen: { type: Boolean, default: false },
		value: { type: [Number, String, Object, Array], default: null },
		options: { type: Array, default: () => [] },
		label: { type: String, required: true },
		tooltip: { type: String, default: '' },
		placeholder: { type: String, default: '' },
		required: { type: Boolean, default: false },
		rules: { type: Object, default: () => ({}) },
		hideTrigger: { type: Boolean, default: false },
		currentRunnit: { type: Object, default: null },
	},
	data () {
		return {};
	},
	computed: {
		headerLabel () {
			// The Kit's name is stored now, so the header follows a rename in
			// Manage Kits instead of needing a deploy.
			const kit = (this.$route && (this.$route.query as any)?.kit) as string | null;
			const resolvedKit = this.getResolvedKit(kit);
			return resolvedKit ? `${resolvedKit.label} Models` : this.label;
		},
		selectedValue () {
			return this.value ? this.options.find((option) => option.value === this.value) : null;
		},
	},
	methods: {
		closeDialog (close) {
			this.$emit('close');
			if (close) {
				close();
			}
		},
        openCompareModels () { // TODO: replace 'placeholder' with the RD articles once they are written
			const kit = (this.$route && (this.$route.query as any)?.kit) as string | null;
			const imageUrl = 'placeholder';
			const videoUrl = 'placeholder';
			const imageEditUrl = 'placeholder';
			const videoEditUrl = 'placeholder';
			const upscaleUrl = 'placeholder';

			let url;
			switch (kit) {
				case KIT_TYPE.image:
					url = imageUrl;
					break;
				case KIT_TYPE.video:
					url = videoUrl;
					break;
				case KIT_TYPE.imageEdit:
					url = imageEditUrl;
					break;
				case KIT_TYPE.videoEdit:
					url = videoEditUrl;
					break;
				case KIT_TYPE.upscale:
					url = upscaleUrl;
					break;
				default:
					url = imageUrl; // fallback to image comparison
					break;
			}
			window.open(url, '_blank');
        },
		onSelectImageOption (option: any, close: () => void) {
			// Update the most-recent kit selection as soon as a user picks a tool
			const kit = (this.$route && (this.$route.query as any)?.kit) as string | null;
			const isValidKit = !!kit && (Object.values(KIT_TYPE) as string[]).includes(kit);
			if (isValidKit && option?.value) {
				setKitPreference(kit as string, String(option.value));
			}

			this.$emit('input', option.value);
			this.closeDialog(close);
		},
		goToAllTools () {
			// Close the dialog first, then navigate
			this.closeDialog();
			this.$nextTick(() => {
				this.routerPush(this.$route, this.$router, { name: 'RunnitsAllTools' });
			});
		},
	},
});
